export default {
  to: 'Кому',
  organizer: 'Органайзер',
  organizer_new: 'Новый органайзер',
  organizer_old: 'Старый органайзер',
  selectTasks: 'Выбрать задачи',
  showCompletedTask: 'Показать выполненные задачи',
  inbox: 'Входящие',
  next7Days: 'След. 7 дней',
  upcoming: 'Предстоящее',
  meeting: 'Встреча',
  author: 'Автор',
  assignees: 'Исполнители',
  task: 'Задача',
  tasks: 'Задачи',
  taskType: 'Тип задачи',
  taskName: 'Название задачи',
  taskPriority: 'Приоритет задачи',
  deleteTask: 'Удалить задачу',
  renameTask: 'Переименовать задачу',
  moveTask: 'Переместить задачу',
  duplicateTask: 'Дублировать задачу',
  addTask: 'Добавить задачу',
  whatAreYouLookingFor: 'Что ищете?',
  priority: 'Приоритет',
  low: 'Низкий',
  normal: 'Обычный',
  high: 'Высокий',
  urgent: 'Срочный',
  opened: 'Открыта',
  completed: 'Выполнена',
  closed: 'Закрыта',
  openedTasks: 'Открытые',
  completedTasks: 'Выполненные',
  closedTasks: 'Закрытые',
  overdueTasks: 'Просрочено',
  due: 'Срок',
  deadDue: 'Крайний срок',
  status: 'Статус',
  organizeAllInformation:
    'Организуйте всю необходимую информацию в одном месте с помощью комментариев к задачам.',
  noTasks:
    'Похоже, все организовано как надо. Нажмите +, чтобы добавить задачу',
  assignToMe: 'Назначить мне',
  searchByTaskName: 'Поиск по названию задачи',
  createNewTask: 'Создать новую задачу',
  createNewFolder: 'Создать новую папку',
  overdueTasksTab: 'Просроченные',
  activeTasksTab: 'Активные',
  completedTasksTab: 'Выполненные',
  newTaskCreated: 'Задача создана',
  newFolderCreated: 'Папка создана',
  taskDeleted: 'Задача удалена',
  taskChanged: 'Задача изменена',
  taskSuccessStatusChanged: 'Статус задачи успешно изменен',
  goToTask: 'Перейти в задачу',
  resultTask: 'Результат задачи',
  inputResultTask: 'Введите результат задачи',
  noTaskName: '(Без названия)',
  cards: 'Карточки',
  list: 'Список',
  onlyPrivate: 'Только личные',
  privateTask: 'Личная задача',
  tag: 'Тег',
  execute: 'Выполнить',
  executeTask: 'Выполнить задачу',
};
